import { Card } from '../atoms/Card/Card';
import { Stack } from '../atoms/Stack/Stack';
import { Section } from '../templates/Section/Section';
import { Text } from '../atoms/Typography/Text';
import { useTranslation } from '../../i18n/useTranslation';
import './DosingSafetyCard.css';

/**
 * Reef Guard (#1822): the dosing rules that prevent the classic accidents — a
 * runaway doser, the panic water change after a spike, unbalanced 2-part dosing.
 */
export function DosingSafetyCard() {
  const { t } = useTranslation();
  const tips = ['reservoir', 'spike', 'twoPart', 'split'] as const;
  return (
    <Section title={t('dosing.safety.title')}>
     <Card data-testid="dosing-safety-card">
      <Stack gap="3">
        <ul className="dosing-safety-card__list">
          {tips.map((tip) => (
            <li key={tip}>
              <Text>
                <strong>{t(`dosing.safety.${tip}.title`)}</strong> {t(`dosing.safety.${tip}.text`)}
              </Text>
            </li>
          ))}
        </ul>
      </Stack>
     </Card>
    </Section>
  );
}
